import { LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { style } from './banner.styles';
import './banner.scss'

/**
 * @slot default - Inhalt
 */
@customElement('sbk-banner')
export class SbkBanner extends LitElement {

    @property()
    variant: 'default' | 'light' | 'dark' | 'neutral' | 'muted' | 'accented' | 'emphasised' = 'default';

    @property({type: Boolean, attribute: 'has-round-border'})
    hasRoundBorder = false;

    static get styles() {
        return style;
    }

    render() {
        return html`
            <div class="banner banner-bg-${this.variant} bg-${this.variant}${this.hasRoundBorder ? ' has-round-border' : ''}">
                <slot></slot>
            </div>
        `;
    }
}
